import { ID, ReorderItem } from '@griply/types';

export const findParentItem = <T extends ReorderItem>(
  items: readonly T[],
  childId: ID,
): T | undefined => items.find(({ children }) => children?.includes(childId));
